import React, { useEffect, useState, useRef } from "react";
import api from "../../utils/apiClient";
import CarBoletin from "../CarBoletin";
import Navbar from "../Navbar";
import Foooter from "../Foooter";
import FooterMovil from "../FooterMovil";
import { AdminSidebar, AdminSidebarDropdown } from "../AdminSidebar";
import "../../style/AllCarsAdmin.css";
import "../../style/BoletinPage.css";
import { useAuth } from "../../context/AuthContext.js";
import { useNavigate } from "react-router-dom";
import Fuse from "fuse.js";
import { notification } from "antd";

function AllCarsAdmin() {
  const [carros, setCarros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [otherloading, setOtherLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [isFiltered, setIsFiltered] = useState(false);
  const [, setError] = useState(null);
  const { authToken, logout } = useAuth();
  const [selectedBrand, setSelectedBrand] = useState("");
  const [marcas, setMarcas] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [fullmarca, setfullmarca] = useState([]);
  const [, setSuggestingModels] = useState(false);
  const [suggestions, setsugestions] = useState([]);
  const [input, setInput] = useState("");
  const [searchType, setSearchType] = useState([]);
  const listRef = useRef(null);
  const offRef = useRef(0);
  const offFilterRef = useRef(0);
  const currentFilterRef = useRef(null);
  // Bumped by every list-replacing fetch; appenders capture it and discard
  // late responses so a superseded "load more" can't mix into a new search.
  const fetchGenRef = useRef(0);
  const PAGE = 30;
  const [username, setUsername] = useState('')
  const [selectedCars, setSelectedCars] = useState([]);
  const [recipients, setRecipients] = useState([]);
  const [showRecipientsModal, setShowRecipientsModal] = useState(false);
  const [loadingRecipients, setLoadingRecipients] = useState(false);
  const [sending, setSending] = useState(false);



  const navigate = useNavigate();

  const getuser = async () => {
    try {
      const response = await api.get("usuario/getbyToken");
      setUsername(response.data.nombre);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to fetch data");
    }
  };

  const handleCarSelection = (car, isSelected) => {
    setSelectedCars((prevSelectedCars) => {
      if (isSelected) {
        // Agregar el carro al array de seleccionados
        return [...prevSelectedCars, car];
      } else {
        // Remover el carro del array de seleccionados
        return prevSelectedCars.filter((selectedCar) => selectedCar._id !== car._id);
      }
    });
  };
  
  
  //todo esto es del searchbar
  function capitalizeFirstLetter(str) {
    if (!str) return str; // Return the original string if it's empty or undefined
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const getMarcas = async () => {
    try {
      const res = await api.get("marcasymodelos/marca");
      const carros = res.data;
      const nombres = carros.map((carro) => carro.Nombre);
      setMarcas(nombres);
      setfullmarca(res.data);
    } catch (error) {
      console.error("Error fetching marcas:", error);
    }
  };

  const getmodelos = async (marcaID) => {
    try {
      const data = { marca: marcaID };
      const res = await api.post("marcasymodelos/modelobymarca", data);
      const modelos = res.data;
      const nombresConMarca = modelos.map(
        (modelo) => `${selectedBrand} ${modelo.Nombre}`
      );
      setModelos(modelos.map((m) => m.Nombre));
      setsugestions(nombresConMarca);
      setSuggestingModels(true);
    } catch (error) {
      console.error("Error fetching modelos by marca:", error);
    }
  };

  const fuse = new Fuse(marcas, {
    threshold: 0.6, // Adjust this value to be more or less strict
    keys: ["marca"],
  });

  const anioPattern = /^\d{4}$/;

  const findObjectByKeyValue = (array, key, value) => {
    return array.find((obj) => obj[key] === value);
  };

  const detectInputType = (value) => {
    setSelectedBrand("");
    const valueTrim = value.trim();
    let parts = valueTrim.split(" ");
    let matches = [];
    const suggestions = fuse.search(parts[0]);
    setsugestions(suggestions.map((suggestion) => suggestion.item));
    parts.forEach((part) => {
      if (marcas.some((marca) => marca.toLowerCase() === part.toLowerCase())) {
        matches.push({ type: "marca", value: capitalizeFirstLetter(part) });
      }
      if (
        modelos.some((modelo) => modelo.toLowerCase() === part.toLowerCase())
      ) {
        matches.push({ type: "modelo", value: capitalizeFirstLetter(part) });
      }
      if (anioPattern.test(part)) {
        matches.push({ type: "anio", value: part });
      }
    });
    if (matches.length === 0) {
      matches.push({ type: "unknown", value: value }); // Fallback if no matches found
    }
    if (matches[0].type === "marca") {
      const algo = findObjectByKeyValue(fullmarca, "Nombre", matches[0].value);
      setSelectedBrand(matches[0].value);
      getmodelos(algo._id);
    }
    setSearchType([...new Set(matches)]);
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setInput(value);
    detectInputType(value);
  };

  const fetchCarrosType = async () => {
    const combinedJson = searchType.reduce((accumulator, current) => {
      accumulator[current.type] = current.value;
      return accumulator;
    }, {});
    fetchGenRef.current += 1;
    setLoading(true);
    setIsFiltered(true);
    currentFilterRef.current = { endpoint: "filter/", body: combinedJson };
    offFilterRef.current = 0;
    setHasMore(true);
    setCarros([]);
    try {
      const filteredResTIPO = await api.post(
        `filter/?offset=0&limit=${PAGE}`,
        combinedJson
      );
      const list = filteredResTIPO.data.carros || [];
      setCarros(list);
      setHasMore(Boolean(filteredResTIPO.data.hasMore));
      offFilterRef.current = list.length;
      setError(null);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to fetch data");
      setCarros([]);
    }
    await setLoading(false);
  };

  const fetchMoreFiltered = async () => {
    // `loading` = an initial fetch is replacing the list; a scroll event during
    // it (the list element shrinking fires a scroll clamp) must not append the
    // same offset-0 page again — same duplicate-cars race as the stock page.
    if (!hasMore || !currentFilterRef.current || loading) {
      setOtherLoading(false);
      return;
    }
    const gen = fetchGenRef.current;
    try {
      const { endpoint, body } = currentFilterRef.current;
      const res = await api.post(
        `${endpoint}?offset=${offFilterRef.current}&limit=${PAGE}`,
        body
      );
      if (gen !== fetchGenRef.current) return; // superseded by a new search
      const list = res.data.carros || [];
      setCarros((prev) => [...prev, ...list]);
      setHasMore(Boolean(res.data.hasMore));
      offFilterRef.current += list.length || PAGE;
    } catch (e) {
      console.error("Failed to fetch filtered items", e);
      setError("Failed to fetch data");
    } finally {
      setOtherLoading(false);
    }
  };

  const fetchMoreUnfiltered = async () => {
    if (!hasMore || loading) {
      setOtherLoading(false);
      return;
    }
    const gen = fetchGenRef.current;
    try {
      const res = await api.get(
        `carro?offset=${offRef.current}&limit=${PAGE}`
      );
      if (gen !== fetchGenRef.current) return; // superseded by a new search
      const list = res.data.carros || [];
      setCarros((prev) => [...prev, ...list]);
      setHasMore(Boolean(res.data.hasMore));
      offRef.current += list.length || PAGE;
    } catch (e) {
      console.error("Failed to fetch items", e);
      setError("Failed to fetch data");
    } finally {
      setOtherLoading(false);
    }
  };

  const navigateToResults = () => {
    fetchCarrosType();
  };

  const handleSearch = () => {
    navigateToResults();
  };

  const detectInputTypeSugestion = (value) => {
    const valueTrim = value.trim();
    let parts = valueTrim.split(" ");
    let matches = [];
    parts.forEach((part) => {
      if (marcas.some((marca) => marca.toLowerCase() === part.toLowerCase())) {
        matches.push({ type: "marca", value: capitalizeFirstLetter(part) });
      }
      if (
        modelos.some((modelo) => modelo.toLowerCase() === part.toLowerCase())
      ) {
        matches.push({ type: "modelo", value: capitalizeFirstLetter(part) });
      }
      if (anioPattern.test(part)) {
        matches.push({ type: "anio", value: part });
      }
    });
    if (matches.length === 0) {
      matches.push({ type: "unknown", value: value }); // Fallback if no matches found
    }
    setSearchType([...new Set(matches)]);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearch();
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setInput(suggestion);
    setsugestions([]);
    detectInputTypeSugestion(suggestion);
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  useEffect(() => {
    const inicio = async () => {
      if (!authToken) {
        navigate("/");
      } 
      getuser()
    }
    const fetchAllCarros = async () => {
      fetchGenRef.current += 1;
      setLoading(true);
      setIsFiltered(false);
      currentFilterRef.current = null;
      offRef.current = 0;
      offFilterRef.current = 0;
      setHasMore(true);
      try {
        const response = await api.get(`carro?offset=0&limit=${PAGE}`);
        const list = response.data.carros || [];
        setCarros(list);
        setHasMore(Boolean(response.data.hasMore));
        offRef.current = list.length;
        setError(null);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to fetch data");
        setCarros([]); // Consider whether you want to reset carros on error
      }
      await setLoading(false);
    };
    inicio()
    fetchAllCarros();
    getMarcas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (otherloading) {
      if (isFiltered) {
        fetchMoreFiltered();
      } else {
        fetchMoreUnfiltered();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otherloading, isFiltered]);

  useEffect(() => {
    const list = listRef.current;
    if (!list) return;
    const onScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = list;
      if (scrollTop + clientHeight >= scrollHeight - 150 && hasMore) {
        setOtherLoading(true);
      }
    };
    list.addEventListener("scroll", onScroll);
    return () => list.removeEventListener("scroll", onScroll);
  }, [hasMore]);

  const sanitizeEmail = (raw) => {
    if (typeof raw !== 'string') return null;
    const e = raw.trim().toLowerCase();
    if (!e || e === 'sincorreo@honduautos.com') return null;
    // Anchored to mirror the backend sanitizeEmails — reject embedded
    // whitespace/newlines or trailing content, only a single address token.
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)) return null;
    return e;
  };

  const openRecipientsModal = async () => {
    if (selectedCars.length === 0) {
      notification.warning({
        message: 'Advertencia',
        description: 'No hay carros seleccionados para el boletín.',
      });
      return;
    }
    setLoadingRecipients(true);
    try {
      const res = await api.get("usuario/");
      const seen = new Set();
      const list = [];
      for (const u of res.data || []) {
        const correo = sanitizeEmail(u?.correo);
        if (!correo || seen.has(correo)) continue;
        seen.add(correo);
        list.push({ correo, included: true });
      }
      setRecipients(list);
      setShowRecipientsModal(true);
    } catch (error) {
      console.error("Error fetching recipients:", error);
      notification.error({
        message: 'Error',
        description: 'No se pudo obtener la lista de correos.',
      });
    } finally {
      setLoadingRecipients(false);
    }
  };

  const toggleRecipient = (correo) => {
    setRecipients((prev) =>
      prev.map((r) => (r.correo === correo ? { ...r, included: !r.included } : r))
    );
  };

  const setAllRecipients = (included) => {
    setRecipients((prev) => prev.map((r) => ({ ...r, included })));
  };

  const closeRecipientsModal = () => {
    if (sending) return;
    setShowRecipientsModal(false);
  };

  const includedCount = recipients.filter((r) => r.included).length;

  const confirmSend = async () => {
    const correos = recipients.filter((r) => r.included).map((r) => r.correo);
    if (correos.length === 0) {
      notification.warning({
        message: 'Advertencia',
        description: 'No hay correos seleccionados.',
      });
      return;
    }
    setSending(true);
    try {
      const res = await api.post("correos/enviar/", {
        cars: selectedCars,
        correos,
      });
      const sent = res?.data?.sent ?? correos.length;
      notification.success({
        message: 'Boletín enviado',
        description: `Se envió a ${sent} ${sent === 1 ? 'correo' : 'correos'}.`,
      });
      setShowRecipientsModal(false);
    } catch (error) {
      console.error("Error sending boletín:", error);
      notification.error({
        message: 'Error',
        description: 'No se pudo enviar el boletín. Inténtalo de nuevo.',
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="containers">
        <div className="main-container-admin-a boletin-page">
          <AdminSidebar username={username} onLogout={handleLogout} />
          <div className="column-info">
            <AdminSidebarDropdown onLogout={handleLogout} />
            <p className="main-admin-title-a">Enviar Boletín</p>
            <div className="bp-toolbar">
              <div className="bp-search">
                <svg
                  className="bp-search-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="11" cy="11" r="7" />
                  <path d="m20 20-3.5-3.5" />
                </svg>
                <input
                  type="text"
                  value={input}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  placeholder="Marca, modelo, lote, etc."
                />
                {suggestions.length > 0 && (
                  <ul className="bp-suggestions">
                    {suggestions.map((suggestion, index) => (
                      <li
                        key={index}
                        onClick={() => handleSuggestionClick(suggestion)}
                        className="bp-suggestion"
                      >
                        {suggestion}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="bp-filters">
                <label className="bp-chip">
                  <input type="checkbox" />
                  Nuevos
                </label>
                <label className="bp-chip">
                  <input type="checkbox" />
                  En Oferta
                </label>
              </div>
              <button
                type="button"
                className="bp-search-btn"
                onClick={handleSearch}
              >
                BUSCAR
              </button>
            </div>

            <div className="bp-list" ref={listRef}>
              {carros.length === 0 ? (
                <p className="bp-empty">
                  {loading ? "Cargando..." : "No hay carros disponibles"}
                </p>
              ) : (
                carros.map((carro) => (
                  <CarBoletin
                    key={carro._id}
                    carro={carro}
                    onSelectionChange={handleCarSelection}
                  />
                ))
              )}
              {otherloading && <p className="bp-empty">Cargando más...</p>}
            </div>

            <div className="bp-footer">
              <span
                className={`bp-counter${selectedCars.length === 0 ? " bp-counter--zero" : ""}`}
              >
                <strong>{selectedCars.length}</strong>{" "}
                {selectedCars.length === 1 ? "carro seleccionado" : "carros seleccionados"}
              </span>
              <button
                type="button"
                className="bp-send"
                onClick={openRecipientsModal}
                disabled={selectedCars.length === 0 || loadingRecipients}
              >
                {loadingRecipients ? 'CARGANDO...' : 'ENVIAR BOLETÍN'}
              </button>
            </div>
          </div>
        </div>
      </div>
      {showRecipientsModal && (
        <div
          className="bp-modal-overlay"
          role="dialog"
          aria-modal="true"
          onClick={closeRecipientsModal}
        >
          <div className="bp-modal" onClick={(e) => e.stopPropagation()}>
            <div className="bp-modal-header">
              <h3>Confirmar destinatarios</h3>
              <button
                type="button"
                className="bp-modal-close"
                onClick={closeRecipientsModal}
                aria-label="Cerrar"
                disabled={sending}
              >
                ×
              </button>
            </div>
            <div className="bp-modal-subheader">
              <span className="bp-modal-counter">
                <strong>{includedCount}</strong> de {recipients.length}{" "}
                {recipients.length === 1 ? 'correo' : 'correos'}
              </span>
              <div className="bp-modal-actions">
                <button
                  type="button"
                  className="bp-modal-link"
                  onClick={() => setAllRecipients(true)}
                  disabled={sending}
                >
                  Seleccionar todos
                </button>
                <button
                  type="button"
                  className="bp-modal-link"
                  onClick={() => setAllRecipients(false)}
                  disabled={sending}
                >
                  Quitar todos
                </button>
              </div>
            </div>
            <ul className="bp-modal-list">
              {recipients.length === 0 ? (
                <li className="bp-modal-empty">No hay correos válidos disponibles.</li>
              ) : (
                recipients.map((r) => (
                  <li
                    key={r.correo}
                    className={`bp-modal-row${r.included ? '' : ' is-excluded'}`}
                  >
                    <label>
                      <input
                        type="checkbox"
                        checked={r.included}
                        onChange={() => toggleRecipient(r.correo)}
                        disabled={sending}
                      />
                      <span>{r.correo}</span>
                    </label>
                  </li>
                ))
              )}
            </ul>
            <div className="bp-modal-footer">
              <button
                type="button"
                className="bp-modal-cancel"
                onClick={closeRecipientsModal}
                disabled={sending}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="bp-modal-confirm"
                onClick={confirmSend}
                disabled={sending || includedCount === 0}
              >
                {sending
                  ? 'Enviando...'
                  : `Enviar a ${includedCount} ${includedCount === 1 ? 'correo' : 'correos'}`}
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="footer">
      <Foooter />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default AllCarsAdmin;
